// Display-name overrides for tables. The actual DB table name + API endpoints
// stay unchanged — these are purely UI-layer aliases for user-friendly naming.
const TABLE_LABEL_OVERRIDES = {
  ELEMENT_TYPE: 'Salary Structure (Components)',
  ADVANCE_SALARY_TYPE: 'ADVANCE SALARY TYPE',
  ADVANCE_SALARY_POLICY: 'ADVANCE SALARY POLICY',
  ADVANCE_SALARY_REQUEST: 'ADVANCE SALARY REQUEST',
  ADVANCE_SALARY: 'ADVANCE SALARY',
  ADVANCE_SALARY_REPAYMENT: 'ADVANCE SALARY REPAYMENT',
  FULL_FINAL_SETTLEMENT: 'Full & Final Settlements',
  BANK_PAYMENT_FILE: 'PAYSLIP DATA',
};

export function tableLabel(name) {
  if (!name) return '';
  if (TABLE_LABEL_OVERRIDES[name]) return TABLE_LABEL_OVERRIDES[name];
  return name.replace(/_/g, ' ');
}
